<template>
  <div style="background-color:white;height: 100%;width: 100%;">
    <el-row :gutter="50">
      <el-col :span="12">
        <el-form :inline="true" class="demo-form-inline" style="float:right">
          <el-form-item label="选择专业">
            <el-select v-model="deviceInfo.id" @change="selectNode" style="width:300px" placeholder="请选择专业">
              <el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
              </el-option> </el-select>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row :gutter="50">
      <el-col :span="12">
        <div style="height:530px;border:1px solid #000">
          <el-table :data="projectData.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
            ref="multipleTable" height="100%" style="width: 100%" highlight-current-row
            @current-change="handleCurrentChange" :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }">
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <!-- <el-table-column prop="id" label="项目id">
          </el-table-column> -->
            <el-table-column prop="name" label="项目名称">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope" slot="header">
                <el-input v-model="search" placeholder="输入关键字搜索" style="width:60%" />
                <el-button style="float:right;width:20%" @click="cliclkAdd()" type="primary" size="small">新增项目</el-button>
              </template>
              <template slot-scope="scope" style="float:right">
                <el-button @click="updatePro(scope.row)" type="text" size="small">修改</el-button>
                <el-button @click="deletePro(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col :span="12">
        <div style="height:530px;border:1px solid #000">
          <el-table :data="typeData.filter(data => !gls || data.deviceName.toLowerCase().includes(gls.toLowerCase()))"
            height="100%" style="width: 100%" :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }">
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="设备名称" prop="deviceName">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope" slot="header">
                <el-input v-model="gls" placeholder="输入关键字搜索" style="width:60%" />
                <el-button @click="addDev()" style="float:right;width:20%" type="primary" size="small">添加类别</el-button>
              </template>
              <template slot-scope="scope">
                <el-button @click="deleteDeviceType(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="id" v-if="false">
            </el-table-column>
          </el-table>
        </div>
      </el-col>
      <!-----------------------------------------------------------设备选择弹框--------------------------------------------------------------------->
      <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false"
      :close-on-press-escape="false" title="项目设备维护"
        style="width:60% !important;margin-left: 400px;">
        <el-cascader v-model="lbmc" style="width:100%" :options="optionsTwo" :props="props" :show-all-levels="false"
          filterable></el-cascader>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" v-preventReClick @click="AddDeviceType">确 定</el-button>
        </span>
      </el-dialog>
      <!-----------------------------------------------------------新增项目--------------------------------------------------------------------->
      <el-dialog :visible.sync="dialogVisible1" :close-on-click-modal="false"
      :close-on-press-escape="false" title="项目信息维护"
        style="width:60% !important;margin-left: 400px;">
        <el-input v-model="input" placeholder="请输入项目名称"></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible1 = false">取 消</el-button>
          <el-button type="primary" v-preventReClick @click="addPro">确 定</el-button>
        </span>
      </el-dialog>
      <!-----------------------------------------------------------修改项目--------------------------------------------------------------------->
      <el-dialog :visible.sync="dialogVisible2" :close-on-click-modal="false"
      :close-on-press-escape="false" title="项目信息维护"
        style="width:60% !important;margin-left: 400px;">
        <el-form :model="questionForm" ref="dataForm" label-position="left" label-width="100px"
          style="width: 90%; margin-left:5%;">
          <el-form-item label="原项目名称" prop="reject" style="width: 90%">
            <el-input :readonly="true" v-model="questionForm.name" />
          </el-form-item>
          <el-form-item label="新项目名称" prop="reject" style="width: 90%">
            <el-input v-model="questionForm.newName" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible2 = false">取 消</el-button>
          <el-button type="primary" v-preventReClick @click="updPro">确 定</el-button>
        </span>
      </el-dialog>
    </el-row>



  </div>
</template>
<script>
import {
  selectByIdProject, selectByIdDevice, selectTreeDeviceType, addProjectDevice, deleteProjectDevice,
  deleteProject, addProject, updateProject
} from "../../api/api";

export default {
  name: "ProjectManage",
  data() {
    return {
      data: [],
      options: [
        { id: "01", name: "道路工程专业" },
        { id: '02', name: '桥梁工程专业' },
        { id: '03', name: "交通工程专业" }
      ],
      projectId: "",
      multipleTable: [],
      optionsTwo: [],
      props: {
        label: 'deviceTypeName',
        value: 'deviceTypeName',
        children: 'deviceTypes',
        expandTrigger: 'click',
        emitPath: false
      },
      input: '',
      search: "",
      gls: "",
      lbmc: "",
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      questionForm: {},
      projectData: [],
      deviceInfo: {
        id: "01"
      },
      typeData: [],
      form: {},
    };
  },
  methods: {
    updPro() {
      var map = {
        id: this.questionForm.id,
        mid: this.questionForm.mid,
        name: this.questionForm.newName
      }
      updateProject(map).then(datas => {
        let { status, message, data } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "warning"
          });
        } else if (status == 200) {
          this.$message.success("修改成功")
          this.selectNode(this.deviceInfo.id);
          this.dialogVisible2 = false;
          this.questionForm={};
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    cliclkAdd() {
      this.dialogVisible1 = true;
    },
    addPro() {
      if (this.input != null && this.input != "") {
        var map = {
          mid: this.deviceInfo.id,
          name: this.input
        }
        addProject(map).then(datas => {
          let { status, message, data } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "warning"
            });
          } else if (status == 200) {
            this.$message.success("添加成功")
            this.selectNode(this.deviceInfo.id);
            this.dialogVisible1 = false;
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
        });
      } else {
        this.$message.warning("请输入名称")
      }
    },
    updatePro(row) {
      this.dialogVisible2 = true;
      this.questionForm.name = row.name
      this.questionForm.id = row.id
      this.questionForm.mid = row.mid
    },
    //删除项目
    deletePro(row) {
      this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteProject(row).then(datas => {
          let { status, message, data } = datas;
          console.log(data)
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            this.$message.success("删除成功")
            this.selectNode(this.deviceInfo.id);
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
        });
      })
    },
    deleteDeviceType(row) {
      this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        var map = {
          name: row.deviceName,
          id: this.projectId,
          mid: this.deviceInfo.id
        }
        deleteProjectDevice(map).then(datas => {
          let { status, message, data } = datas;
          console.log(data)
          if (status == 400) {
            this.$message({
              message: message,
              type: "error"
            });
          } else if (status == 200) {
            this.$message.success("删除成功")
            this.handleCurrentChange(map);
          } else {
            this.$message({
              message: "请求错误",
              type: "error"
            });
          }
        });
      })
    },
    addDev() {
      if (this.deviceInfo.id == null) {
        this.$message.warning("请选择专业")
      } else if (this.projectId == null || this.projectId == "") {
        this.$message.warning("请选择项目")
      } else {
        this.dialogVisible = true;
      }
    },
    AddDeviceType() {
      var map = {
        name: this.lbmc,
        mid: this.deviceInfo.id,
        id: this.projectId
      }
      addProjectDevice(map).then(datas => {
        let { status, message, data } = datas;
        console.log(data)
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.$message.success("添加成功")
          this.dialogVisible = false;
          this.handleCurrentChange(map);
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
    findAllType() {
      selectTreeDeviceType().then(datas => {
        let { status, message, data } = datas;
         if (status == 200) {
          this.optionsTwo = this.getTreeData(data);
        }
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].deviceTypes.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].deviceTypes = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].deviceTypes);
        }
      }
      return data;
    },
    selectNode(row) {
      selectByIdProject(row).then(datas => {
        let { status, message, data } = datas;
         if (status == 200) {
          console.log(data)
          this.projectData = data
          this.typeData = [];
          this.projectId = "";
        }
      });
    },
    handleCurrentChange(val) {
      if (val != null) {
        var map = {
          id: val.id,
          mid: this.deviceInfo.id
        }
        this.projectId = val.id
        selectByIdDevice(map).then(datas => {
          let { status, message, data } = datas;
           if (status == 200) {
            // this.typeData=[];
            this.typeData = data
          }
        });
      }
    },
    findAll() {
      findAllWorkflow().then(datas => {
        let { status, message, data } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error"
          });
        } else if (status == 200) {
          this.options = data
        } else {
          this.$message({
            message: "请求错误",
            type: "error"
          });
        }
      });
    },
  },
  created() {
    this.findAllType();
    this.selectNode(this.deviceInfo.id)
  },
};
</script>
<style >
.el-checkbox__inner {
    border: 1px solid #606266!important;
}
</style>
<style scoped></style>
  


// WEBPACK FOOTER //
// src/views/SystemSettings/ProjectManage.vue